<ng-template ngFor let-section [ngForOf]="layout.sections" [ngForTrackBy]="trackByIndex">

  <ng-container [ngSwitch]="section.sectionLayout">
    <ng-container *ngSwitchCase="sectionLayoutType.NO_FORM_REF" [ngSwitch]="section.sectionType">

      <ng-container *ngSwitchCase="sectionType.COLUMN" [ngSwitch]="section.sectionColumnInfoType">
        <div *ngSwitchCase="sectionColumnLayoutType.DISTRIBUTED_NO_FIRST"
          class="row" attr-data-test="lm-form-standard: section.type is column"
        >
          <ng-template visiblewhen [layoutObject]="section" [model]="model" [specFields]="specFields">
            <lm-columns-distributed
                [layoutObject]="section"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="section.columnLayoutInfo"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
                class="form-layout-element"
            ></lm-columns-distributed>
          </ng-template>
        </div>
        <ng-container *ngSwitchCase="sectionColumnLayoutType.UNDISTRIBUTED">
          <ng-template visiblewhen [layoutObject]="section" [model]="model" [specFields]="specFields">
            <lm-columns-undistributed
                [ngClass]="{
                  'lm-number-label-row': section.displayAsNumberLabelSection,
                  'lm-single-column': section.columnLayoutInfo.nbrColumns === 1,
                  'form-layout-element': true
                }"
                [layoutObject]="section"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="section.columnLayoutInfo"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-columns-undistributed>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="sectionColumnLayoutType.IMAGE_IN_FIRST_COLUMN">
          <lm-columns-image-first-column
              [layoutObject]="section"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="section.columnLayoutInfo"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
              [ngClass]="{
                'lm-number-label-row': section.displayAsNumberLabelSection,
                'lm-single-column': section.columnLayoutInfo.nbrColumns === 1,
                'form-layout-element': true
              }"
          ></lm-columns-image-first-column>
        </ng-container>
        <div *ngSwitchCase="sectionColumnLayoutType.IS_TABLE" lm-form-layout [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row': true }" attr-data-test="lm-form-standard: section.type is column">
          <ng-template visiblewhen [layoutObject]="section" [model]="model" [specFields]="specFields">
            <lm-columns-table
                [layoutObject]="section"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="section.columnLayoutInfo"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
                class="form-layout-element"
            ></lm-columns-table>
          </ng-template>
        </div>
        <div
            *ngSwitchCase="sectionColumnLayoutType.IS_PERCENT"
            lm-form-layout
            class="row"
            attr-data-test="lm-form-standard: section.type is column"
        >
          <lm-columns-percent
              [layoutObject]="section"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [layoutInfo]="layoutInfo"
              [parentIsModal]="parentIsModal"
              [lmColumnLayoutInfo]="section.columnLayoutInfo"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
              class="form-layout-element"
          ></lm-columns-percent>
        </div>
        <ng-container *ngSwitchCase="sectionColumnLayoutType.IS_GRID">
          <ng-template visiblewhen [layoutObject]="section" [model]="model" [specFields]="specFields">
            <lm-columns-grid
                [layoutObject]="section"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="section.columnLayoutInfo"
                [model]="model"
                [activatedTabChanged]="activatedTabChanged"
                (fieldEvent)="onFieldEvent($event)"
                class="form-layout-element"
            >
            </lm-columns-grid>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="sectionType.HEADER">
        <ng-template visiblewhen [layoutObject]="section.header" [model]="model" [specFields]="specFields" attr-data-test="lm-form-standard: section.type is header">
          <div [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row lm-header-row form-layout-element': true}">
            <lm-header
              [layoutObject]="section.header"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [layoutInfo]="layoutInfo"
              [model]="model"
              [formOptions]="formOptions"
              [specFields]="specFields"
              [formPersonalization]="formPersonalization"
              [formSpec]="formSpec"
              [formState]="formState"
              [activatedTabChanged]="activatedTabChanged"
              [parentIsModal]="parentIsModal"
              [previousSiblingIsCollapsible]="section.previousSiblingIsCollapsibleHeader"
              (fieldEvent)="onFieldEvent($event)"
            ></lm-header>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="sectionType.FIELD">
        <ng-template visiblewhen [layoutObject]="section.field" [model]="model" [specFields]="specFields">
          <div [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row': true}">
            <lm-field *ngIf="!section.field.cfgHidden"
              class="columns twelve form-layout-element"
              [layoutObject]="section.field"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [parentIsFormLayout]="true"
              [layoutInfo]="layoutInfo"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
            ></lm-field>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="sectionType.TEXT">
        <ng-template visiblewhen [layoutObject]="section.text" [model]="model" [specFields]="specFields">
          <div [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row form-layout-element': true}">
            <lm-text
              [layoutObject]="section.text"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="lmColumnLayoutInfo"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
              [ngClass]="{'field': true, 'has-no-label is-section': section.text?.type === 'formtext'}"
            ></lm-text>
          </div>
        </ng-template>
      </ng-container>

      <div *ngSwitchCase="sectionType.PARAGRAPH" [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row form-layout-element': true}">
        <ng-template visiblewhen [layoutObject]="section.paragraph" [model]="model" [specFields]="specFields">
          <lm-paragraph
            [layoutObject]="section.paragraph"
            [lmParagraphLayoutInfo]="section.paragraphLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [layoutInfo]="layoutInfo"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
            [ngClass]="{
              'lm-summary-form': section.paragraphLayoutInfo?.sectionInfo?.isSummaryFormSection,
              'lm-no-label-section': section.paragraphLayoutInfo?.sectionInfo?.isNoLabelSection
              }"
          ></lm-paragraph>
        </ng-template>
      </div>

      <div *ngSwitchCase="sectionType.CAPTCHA_CONTROL" [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'row form-layout-element': true}">
        <ng-template visiblewhen [layoutObject]="section.captchaControl" [model]="model" [specFields]="specFields">
          <lm-captcha-control [layoutObject]="section.captchaControl"></lm-captcha-control>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="sectionLayoutType.FORM_REF">
      <div *ngIf="section.formRef.type==='instancecountchart'">

	      <!--
    	  todo khollenbeck: no fromDataview here.
	      NOTE: I don't think instance count charts on a forms will use a fromDataView, they will use the forms dataView.
    	  [fromDataView]="fromDataView"
	      -->

        <!--
          ivy error
          lm-form-layout.component.html(208,11): Property 'fromDataView' does not exist on type 'LMFormLayoutComponent'.
          [fromDataView]="fromDataView"
         -->
        <lm-form-content-instancechart #LMInstanceChart
          [formSpec]="formSpec"
          [model]="model"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [formState]="formState"
          [formPersonalization]="formPersonalization"
          [chartFields]="section.formRef.chart.fields"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-form-content-instancechart>
      </div>
      <lm-form-layout *ngIf="section.formRef.type!=='instancecountchart'"
        [formSpec]="formSpec"
        [formOptions]="formOptions"
        [specFields]="specFields"
        [layout]="section.formRef.layout"
        [model]="model"
        [formState]="formState"
        [placeHolder]="placeHolder"
        [formPersonalization]="formPersonalization"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-form-layout>
    </ng-container>

    <ng-container *ngSwitchCase="sectionLayoutType.BUTTON">
      <ng-template visiblewhen [layoutObject]="section.button" [model]="model" [specFields]="specFields">
        <lm-button *ngIf="!section.button.cfgHidden"
          [ngClass]="{'lm-number-label-row': section.displayAsNumberLabelSection, 'form-layout-element': true}"
          [layoutObject]="section.button"
          [specFields]="specFields"
          [layoutInfo]="layoutInfo"
          [model]="model"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-button>
      </ng-template>
    </ng-container>

    <ng-container></ng-container>
  </ng-container>

</ng-template>
